
import React from 'react';

interface PricingToggleProps {
  isAnnual: boolean;
  setIsAnnual: (isAnnual: boolean) => void;
}

const PricingToggle: React.FC<PricingToggleProps> = ({ isAnnual, setIsAnnual }) => {
  return (
    <div className="text-center mb-10">
      <div className="inline-block p-1 bg-gray-700/50 backdrop-blur-sm rounded-2xl border border-gray-700/30 shadow-lg">
        <button 
          onClick={() => setIsAnnual(false)}
          className={`py-2 px-4 rounded-xl transition-all duration-300 ${
            !isAnnual 
              ? 'bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-md shadow-blue-500/20' 
              : 'text-gray-300 hover:bg-gray-700/30'
          } font-medium`}
        >
          Monthly
        </button>
        <button 
          onClick={() => setIsAnnual(true)}
          className={`py-2 px-4 rounded-xl transition-all duration-300 ${
            isAnnual 
              ? 'bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-md shadow-blue-500/20' 
              : 'text-gray-300 hover:bg-gray-700/30'
          } font-medium`}
        >
          Annual
        </button>
      </div>
    </div>
  );
};

export default PricingToggle;
